export default {
    home: "Эхлэл",
    welcome: "Тавтай морил",
    calendar: "Календарь",
    information: "Мэдээлэл",
    dictionary: "Толь бичиг",
    searchTerm: "Хайх үгээ оруулна уу",
    search: "Хайх",
    noSearchResults: "Хайлт илэрцгүй",
    writeAnArticle: "Нийтлэл бичих",
    article: "Нийтлэл",
    photo: "Зураг",
    publish: "Нийтлэх",
    photoAlbum: "Зургийн цомог",
    logout: "Гарах",
    ubtzYouthAddress:"210535, Монгол улс, Улаанбаатар хот, Баянгол дүүрэг, Сөүлийн гудамж-42, “УБТЗ” ХНН-ийн удирдах газар",
    changeLanguage: "Хэл солих",
  };